import React, { useEffect, useRef } from "react";

const RARITY_CONFIG = {
  Legendary: {
    bg:        "radial-gradient(ellipse at center, #ff9800 0%, #e65100 40%, #1a0800 100%)",
    colour:    "#ff9800",
    label:     "LEGENDARY",
    emoji:     "🧡",
    particles: 30,
  },
  Mythic: {
    bg:        "radial-gradient(ellipse at center, #fff176 0%, #f9a825 35%, #0a0612 100%)",
    colour:    "#ffeb3b",
    label:     "MYTHIC",
    emoji:     "💛",
    particles: 50,
  },
  Ultra: {
    bg:        "radial-gradient(ellipse at center, #ffffff 0%, #e040fb 20%, #00e5ff 50%, #0a0612 100%)",
    colour:    "#ff2d78",
    label:     "U L T R A",
    emoji:     "🌈",
    particles: 80,
  },
};

function randomBetween(a, b) { return a + Math.random() * (b - a); }

export default function EpicReveal({ image, rarity, onDone }) {
  const canvasRef = useRef(null);

  // cfg may be undefined for non-epic rarities — hooks must still run unconditionally
  const cfg = RARITY_CONFIG[rarity] || null;

  useEffect(() => {
    // skip canvas animation if this rarity has no config
    if (!cfg) return;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx     = canvas.getContext("2d");
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = Array.from({ length: cfg.particles }, () => ({
      x:      randomBetween(0, canvas.width),
      y:      randomBetween(0, canvas.height),
      vx:     randomBetween(-3, 3),
      vy:     randomBetween(-6, -1),
      size:   randomBetween(4, 14),
      alpha:  1,
      colour: rarity === "Ultra"
        ? `hsl(${Math.random()*360},100%,65%)`
        : cfg.colour,
      spin:  randomBetween(-0.15, 0.15),
      angle: 0,
    }));

    let raf;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x     += p.vx;
        p.y     += p.vy;
        p.vy    += 0.08;
        p.alpha -= 0.008;
        p.angle += p.spin;
        if (p.alpha <= 0) {
          p.x     = randomBetween(0, canvas.width);
          p.y     = canvas.height + 10;
          p.vy    = randomBetween(-8, -3);
          p.alpha = 1;
        }
        ctx.save();
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.angle);
        ctx.fillStyle   = p.colour;
        ctx.shadowColor = p.colour;
        ctx.shadowBlur  = 12;
        ctx.fillRect(-p.size/2, -p.size/2, p.size, p.size);
        ctx.restore();
      });
      raf = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(raf);
  }, [cfg, rarity]); // eslint-disable-line react-hooks/exhaustive-deps

  // don't render anything if rarity not in config
  if (!cfg) return null;

  return (
    <div className="epic-overlay" style={{ background: cfg.bg }}>
      <canvas ref={canvasRef} className="epic-canvas" />
      <div className="epic-content">
        <div className="epic-emoji">{cfg.emoji}</div>
        <div className="epic-label" style={{ color: cfg.colour }}>{cfg.label}</div>
        <div className="epic-card">
          <img src={image.image} alt={image.name} className="epic-img" />
        </div>
        <div className="epic-name">{image.name}</div>
        <button className="epic-close-btn" onClick={onDone}>Tap to collect</button>
      </div>
    </div>
  );
}